import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const Toast = ({ message, onDismiss }) => {
  const handleDismiss = useCallback(() => {
    if (onDismiss) {
      onDismiss();
    }
  }, [onDismiss]);

  if (!message) return null;

  return (
    <div className={styles.toast}>
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <span>{message}</span>
      <button onClick={handleDismiss}>×</button>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
};

export default Toast;